var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeCommit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0703 5.40625C12.7422 7.51172 10.9375 9.125 8.75 9.125C6.53516 9.125 4.73047 7.51172 4.40234 5.40625H0.65625C0.273438 5.40625 0 5.13281 0 4.75C0 4.39453 0.273438 4.09375 0.65625 4.09375H4.40234C4.73047 1.98828 6.53516 0.375 8.75 0.375C10.9375 0.375 12.7422 1.98828 13.0703 4.09375H16.8438C17.1992 4.09375 17.5 4.39453 17.5 4.75C17.5 5.13281 17.1992 5.40625 16.8438 5.40625L13.0703 5.40625ZM8.75 7.8125C10.418 7.8125 11.8125 6.44531 11.8125 4.75C11.8125 3.08203 10.418 1.6875 8.75 1.6875C7.05469 1.6875 5.6875 3.08203 5.6875 4.75C5.6875 6.44531 7.05469 7.8125 8.75 7.8125Z",
    fill: "#666C74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeCommit);
export default __webpack_public_path__ + "static/media/code-commit.21a9bf824dae288325ec65fa318290d3.svg";
export { ForwardRef as ReactComponent };